import { useCallback, useState } from 'react'

import { useSafetyTranslation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { CockpitFilterSummary } from '../../../components/cockpitFilterSummary'
import { CockpitTileTitle } from '../../../components/cockpitTileTitle'
import { DocumentsFullscreen } from '../documentsFullscreen/DocumentsFullscreen'

import styles from './CockpitDocumentsAndLinksTitle.module.scss'

interface IProps {
  title: string
  expanded: boolean
  onToggle: () => void
  partnerId?: string
  isManagerCockpitMode?: boolean
}
export const CockpitDocumentsAndLinksTitle = ({
  title,
  expanded,
  onToggle,
  partnerId,
  isManagerCockpitMode,
}: IProps) => {
  const t = useSafetyTranslation()
  const [fullscreen, setFullscreen] = useState(false)
  const openFullscreen = useCallback(() => setFullscreen(true), [])
  const closeFullscreen = useCallback(() => setFullscreen(false), [])
  return (
    <div className={styles.root}>
      <CockpitTileTitle
        title={title}
        expanded={expanded}
        onToggle={onToggle}
        fullscreen={
          isManagerCockpitMode
            ? {
                label: t(FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.fullscreen.open),
                onOpen: openFullscreen,
              }
            : undefined
        }
      >
        <CockpitFilterSummary expanded={expanded} bordered={false} period />
      </CockpitTileTitle>
      {isManagerCockpitMode && (
        <DocumentsFullscreen
          show={fullscreen}
          title={title}
          partnerId={partnerId}
          isManagerCockpitMode
          onClose={closeFullscreen}
        />
      )}
    </div>
  )
}
